var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import { useQuiMenu } from "../QuiMenu/QuiMenuContext.js";
export function QuiNavAvatarMenuButton(_a) {
    var { imageUrl, className, style = {} } = _a, otherProps = __rest(_a, ["imageUrl", "className", "style"]);
    const { isOpen, refs, getReferenceProps } = useQuiMenu();
    const cn = classNames(className, "qui-nav-avatar-menu-button", {
        "qui-nav-avatar-menu-button-active": isOpen,
    });
    const css = imageUrl
        ? Object.assign({ backgroundImage: `url(${imageUrl})` }, style) : {};
    return React.createElement("button", Object.assign({ type: "button", className: cn, style: css, ref: refs.setReference }, getReferenceProps(), otherProps));
}
